import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { Button } from 'antd';

interface ServiceHomePart4Props {}

const HomePart5: React.FC<ServiceHomePart4Props> = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const navigate = useNavigate();

    const [lang, setLang] = useState<'zh' | 'en'>('zh');

    useEffect(() => {
        const l = localStorage.getItem('siteLanguage') || 'zh';
        setLang(l === 'en' ? 'en' : 'zh');
    }, []);

    /** ---------------  
     *   中英文文案  
     * ---------------*/
    const text = {
        zh: {
            title: "NEXTOOK 科技产品",
            tryBtn: "立即试用",

            items: [
                {
                    title: "让律师获客无忧",
                    desc: "以“AI 分身”为核心亮点，能复制律师个人IP风格与语言语态，实现拟人化多轮对话，精准回应客户常见的法律问题，且7×24 小时在线，做到秒级响应，避免律师因响应慢导致的客户流失。"
                },
                {
                    title: "海量数据支持",
                    desc: "海量且多元的专业数据支持，这些数据不仅覆盖法律业务全场景，还通过持续更新与精准分类，保障了AI应用的权威性和实用性。"
                },
                {
                    title: "大幅提升工作效率",
                    desc: "AI分身经海量法律语料训练，能精准匹配法条、判例，回答符合法律规范。它能接管客户第一时间的咨询，让律师从繁杂重复工作中解放，专注于阅卷、庭审等核心事务。"
                },
                {
                    title: "打通法律服务的最后一公里",
                    desc: "凭借技术优势，通过下沉服务渠道、简化服务流程、优化资源配置等方式，精准破解这些难题，真正让法律服务触达基层群众与各类细分场景。"
                }
            ]
        },

        en: {
            title: "NEXTOOK Technology Products",
            tryBtn: "Try Now",

            items: [
                {
                    title: "Worry-free Client Acquisition for Lawyers",
                    desc: "Powered by the AI Persona, which replicates a lawyer’s IP style and tone, enabling human-like multi-turn conversations, answering common legal questions 24/7 with instant response, preventing client loss due to slow replies."
                },
                {
                    title: "Massive Data Support for Lawyers Services",
                    desc: "Supported by extensive and diverse professional data covering full legal service scenarios, continuously updated and precisely categorized to ensure the authority and practicality of AI applications."
                },
                {
                    title: "Significant Efficiency Improvement",
                    desc: "The AI Persona is trained on massive legal corpora, able to match statutes and cases accurately. It handles initial client consultations, freeing lawyers from repetitive tasks to focus on core work such as reviewing files and court hearings."
                },
                {
                    title: "Bridging the Last Mile of Legal Services",
                    desc: "With technological advantages, it solves key challenges by expanding service channels, simplifying processes, and optimizing resource allocation—making legal services accessible to grassroots communities and various niche scenarios."
                }
            ]
        }
    };

    const t = text[lang];

    return (
        <div className='home-home-part4'>
            <div className='home-home-part4-inner'>
                {/* 标题 + 按钮 */}
                <div className="home-part4-h1">
                    <div>{t.title}</div>
                    <Button
                        type="primary"
                        style={{ marginTop: '0', backgroundColor: '#ac9455' }}
                        onClick={() => {
                            window.open('https://ucs.law.ipcn.cn/#/pages/getIn/getIn', '_blank');
                        }}
                    >
                        {t.tryBtn}
                    </Button>
                </div>

                {/* 四个块内容 */}
                <div className="home-part4-item">
                    {t.items.map((item, index) => (
                        <div className="home-part4-inner-item" key={index}>
                            <p className='home-part4-inner-item-first' style={{ color: '#7e694f' }}>
                                {item.title}
                            </p>
                            <div className='home-part4-line'></div>
                            <div className='home-part4-inner-item-second'>
                                {item.desc}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default HomePart5;
